import angular from "angular";

angular
    .module('app')
    .component('individualStudentsControl', {
        template: require('./individual-students-control.html'),
        controller: ['$http', 'Notifier', 'ErrorResponseParser', '$uibModal','moment', controller],
        bindings: {
            course: '<',
            inputParams: '<'
        }
    });

function controller($http, Notifier, ErrorResponseParser, $uibModal,moment) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '20';
    $ctrl.search = null;
    $ctrl.status = null;
    $ctrl.type = null;
    $ctrl.students = null;
    $ctrl.startDate = null;
    $ctrl.endDate = null;

    $ctrl.orderBy = 'created_at';
    $ctrl.orderDir = 'desc';

    $ctrl.$onInit = function () {
        if ($ctrl.inputParams && $ctrl.inputParams.status) {
            $ctrl.status = $ctrl.inputParams.status;
        }
        console.log($ctrl.course);
        $ctrl.getList();
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.status = null;
        $ctrl.type = null;
        $ctrl.startDate = null;
        $ctrl.endDate = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.perPageChanged = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.getList = function () {

        $http
            .get(`/admin/courses/${$ctrl.course.id}/individual-training/get-students`, {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    search: $ctrl.search,
                    type: $ctrl.type,
                    status: $ctrl.status,
                    start_date: $ctrl.startDate ? moment($ctrl.startDate).format('YYYY-MM-DD H:m') : null,
                    end_date: $ctrl.endDate ? moment($ctrl.endDate).format('YYYY-MM-DD H:m') : null,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir
                }
            })
            .then(
                function (response) {
                    $ctrl.students = response.data.data;

                    $ctrl.total = response.data.total;
                    $ctrl.students.forEach(function (student, ind) {
                        student.number = ($ctrl.page - 1) * $ctrl.perPage + ind + 1;

                        let currentLesson = student.lesson_statuses.find(v => v.status == 'current');

                        if (currentLesson) {
                            student.currentLessonInfo = findLessonById(currentLesson.lesson_id);
                        }
                    });
                },
                function (error) {
                }
            );
    };

    function findLessonById(lessonId) {
        for (let i = 0; i < $ctrl.course.chapters.length; i++) {
            for (let j = 0; j < $ctrl.course.chapters[i].lessons.length; j++) {
                if ($ctrl.course.chapters[i].lessons[j].id == lessonId) {
                    return {
                        chapterInd: i,
                        lessonInd: j,
                        title: $ctrl.course.chapters[i].lessons[j].title
                    };
                }
            }
        }
        return null;
    }

    $ctrl.openUserCourseControl = function (user, ind) {

        $uibModal
            .open({
                component: 'userCourseControl',
                resolve: {
                    user: function () {
                        return user;
                    },
                    course: function () {
                        return $ctrl.course;
                    }
                },
                size: 'lg',
            })
            .result
            .then(
                function (response) {
                    if (response.action == 'detach') {
                        $ctrl.students.splice(ind, 1);
                        $ctrl.total--;
                    }

                    if (response.status){
                        user.course_status = response.status;
                    }
                },
                function () {
                }
            );
    };

    $ctrl.openImportModal = function () {
        $uibModal
            .open({
                component: 'individualImportStudentsModal',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                },
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
            })
            .result
            .then(
                function () {
                    $ctrl.orderBy = 'attached_at';
                    $ctrl.orderDir = 'desc';
                    $ctrl.reset();
                },
                function () {
                }
            );
    };

    $ctrl.openAttachStudentModal = function () {
        $uibModal
            .open({
                component: 'individualStudentAttach',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (response) {
                    $ctrl.attachUserToCourse(response);
                },
                function (error) {

                }
            );
    };

    $ctrl.openAddNewStudentModal = function () {
        $uibModal
            .open({
                component: 'userCreateForm',
                size: 'md',
                backdrop: 'static',
                keyboard: false
            })
            .result
            .then(
                function (response) {
                    $ctrl.attachUserToCourse(response);
                },
                function (error) {
                }
            );
    };

    $ctrl.attachUserToCourse = function (data) {

        $http
            .post(`/admin/courses/${$ctrl.course.id}/individual-training/attach-student`,{user_id: data.id})
            .then(
                function () {

                    let user = {
                        id: data.id,
                        full_name: data.full_name,
                        phone: data.phone,
                        pivot: {created_at:moment()},
                        course_status: 'active',
                        lesson_statuses: []
                    };

                    $ctrl.course.chapters.forEach((chapter, chapterInd) => {
                        chapter.lessons.forEach((lesson, lessonInd) => {
                            user.lesson_statuses.push({
                                lesson_id: lesson.id,
                                can_open: lesson.can_open,
                                status: !chapterInd && !lessonInd ? 'current' : 'closed'
                            });
                        });
                    });

                    $ctrl.students.unshift(user);

                    $ctrl.students.forEach(function (user, ind) {
                        user.number = ($ctrl.page - 1) * $ctrl.perPage + ind + 1;
                    });

                    Notifier.success('Пользователь успешно добавлен к курсу', 3);

                },
                function (error) {
                    Notifier.error(error.data.message, 2);
                    $ctrl.loading = false;
                }
            )
    }

}
